export default __webpack_public_path__ + "static/media/e18.a53b02b8.jpg";